const UNE_MINUTE = 60 * 1000;
const CINQ_MINUTES = 5 * UNE_MINUTE;
const UNE_HEURE = 60 * UNE_MINUTE;


function setIntervalNow(fn, t) {
    fn();
    return (setInterval(fn, t));
}
function isEmoji(str) {
    const regex = /\p{Extended_Pictographic}/ug
    return regex.test(str);
}

function compterEmoji(str) {
    try {
        return [...new Intl.Segmenter().segment(str)].length
    } catch (e) {
        let count = 0;
        let arr = [...str];

        for (c = 0; c < arr.length; c++) {
            if (
                arr[c] != '\u{200D}' &&
                arr[c + 1] != '\u{200D}' &&
                arr[c + 1] != '\u{fe0f}' &&
                arr[c + 1] != '\u{20e3}'
            ) {
                count++;
            }
        }
        return count;
    }
}

function px(valeur) {
    if (valeur && !isNaN(valeur)) {
        valeur += 'px';
    }

    return valeur;
}
function getCanonical() {
    let url = document.querySelector('[rel="canonical"]')?.getAttribute('href');
    if (!url) {
        url = document.location.href.split('?')[0];
    }
    return url;
}

// https://stackoverflow.com/a/70013865
function getCssVar(style, selector = false) {

    let element;
    if (selector) {
        element = document.querySelector(selector)
    } else {
        element = document.body;
    }

    // Exit if element doesn't exist
    if (!element) return false

    return getComputedStyle(element).getPropertyValue(style);
}

/**
 * Retire tous les messages sur le .field entourant un champ input (cf 00-forms.kit)
 * @param {HTMLElement} field
 */
function resetFormFieldMessage(field) {
    if (field.dataset?.error) {
        delete field.dataset.error;
    }
    if (field.dataset?.warning) {
        delete field.dataset.warning;
    }
    if (field.dataset?.success) {
        delete field.dataset.success;
    }
    let input = field.querySelector('input');
    if (input) {
        input.setCustomValidity("");
    }
}

/**
 * Renseigne un message sur le .field entourant un champ input (cf 00-forms.kit)
 * @param {HTMLElement} field div .field autour du champ
 * @param {string} type warning, error or success
 * @param {string} message
 */
function formFieldMessage(field, type, message) {
    resetFormFieldMessage(field);
    field.dataset[type] = message;
    if (type == "error") {
        let input = field.querySelector('input');
        if (input) {
            input.setCustomValidity(message);
            // input.reportValidity();
        }
    }
}

/**
 * Indique si le site s'affiche  dans l'une des étapes responsive donnée en parametre
 * @param {array} strs
 */
function isBreakpoint(strs) {
    if (typeof strs == 'string') {
        strs = [strs];
    }
    for (let str of strs) {
        if (validerEtape(str)) {
            return true;
        }
        if (validerBreakpoint(str)) {
            return true;
        }
    }

}
/**
 * Indique si le site s'affiche  dans l'etape responsive donnée en parametre
 * @param {string} etape
 */
function validerEtape(etape) {
    etape = etape ? etape.trim() : false;


    if (document.body.dataset.etape == etape) {
        return true;
    }

    if (etape) {
        return false;
    }

    return true;
}
/**
 * Indique si le site s'affiche  dans le breakpoint responsive donnée en parametre
 * @param {string} breakpoint
 */
function validerBreakpoint(breakpoint) {
    breakpoint = breakpoint ? breakpoint.trim() : false;
    if (document.body.dataset.breakpoint == breakpoint) {
        return true;
    }

    if (breakpoint) {
        return false;
    }

    return true;
}
/**
 * Remplace la couleur blanche d'une photo par de la transparence
 * @param {DOMElement} image 
 * @param {int} threshold tolérance sur la couleur à remplacer 
 */
function fondTransparent(image, threshold = 35) {
    const backgroundColor = { red: 255, green: 255, blue: 255 };

    const imageElement = new Image();
    imageElement.src = image.src;
    imageElement.addEventListener('load', () => {

        var canvas = document.createElement('canvas');
        canvas.width = imageElement.naturalWidth;
        canvas.height = imageElement.naturalHeight;

        var ctx = canvas.getContext('2d');
        ctx.drawImage(imageElement, 0, 0);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < imageData.data.length; i += 4) {
            const red = imageData.data[i];
            const green = imageData.data[i + 1];
            const blue = imageData.data[i + 2];
            if (Math.abs(red - backgroundColor.red) < threshold &&
                Math.abs(green - backgroundColor.green) < threshold &&
                Math.abs(blue - backgroundColor.blue) < threshold) {
                imageData.data[i + 3] = 0;
            }
        }

        ctx.putImageData(imageData, 0, 0);
        let resultat = canvas.toDataURL(`image/png`);
        image.src = resultat;
    });
}

function loading() {
    return '<div data-loading="true"></div>';
}

/**
 * Réduire une valeur de 1000 à 1k
 *
 * @param  mixed valeur
 * @return string
 */
function reduireValeur(valeur) {
    valeur = parseInt(valeur);
    if (valeur > 1000) {
        valeur = (Math.round(valeur / 1000 * 10) / 10).toFixed(1) + 'k';
    }
    return valeur.toString();
}

function fromFixedToRelative(element) {
    element.style.top = element.dataset.top
    element.style.left = element.dataset.left
    element.style.width = element.dataset.width
    element.style.height = element.dataset.height
    setTimeout(() => {
        delete element.dataset.fullscreen;
        setTimeout(() => {
            element.classList.remove('animated-fixed');
        }, 400)
    }, 100)
}

/**
 * Positionne un element placé en relatif en fixed, avec une transition visible
 * @param {DomElement} element 
 */
function fromRelativeToFixed(element) {

    let top = element.offsetTop;
    let left = element.offsetLeft;
    let width = element.offsetWidth;
    let height = element.offsetHeight;

    element.dataset.top = element.style.top = top + 'px';
    element.dataset.left = element.style.left = left + 'px';
    element.dataset.width = element.style.width = width + 'px';
    element.dataset.height = element.style.height = height + 'px';
    element.classList.add('animated-fixed');

    setTimeout(() => {
        element.dataset.fullscreen = true;
        element.style.top = 0;
        element.style.left = 0;
        element.style.width = '100%';
        element.style.height = '100%';
    }, 100)
    console.log(top, left, width, height)
}
/**
 * Simulation d'une page vue : changement de l'url dans la barre d'adresse + emeission d'un event custom
 * @param {string} url 
 * @param {string} titre 
 */
function simulerPageVue(url, titre) {
    let suffix = document.title.split(' - ').pop() || document.title;
    document.title = titre + ' - ' + suffix;
    if (document.location.href.includes('localhost')) {
        console.log(url);
    } else {
        window.history.pushState({}, titre, url);
    }
    emettreEvenement('page-vue');
}
/**
 * Mettre le focus dans une zone de saisie a la fin
 * @param {*} element 
 */
function setFocus(element) {
    element.focus();
    setTimeout(() => { element.selectionStart = element.selectionEnd = 10000; }, 0);
}

/**
 * Recuperer le contenu d'un template avec son nom
 * @param {string} name Le nom du template 
 * @param {Object} data Les données à parser dans le template
 * @returns mixed
 */
function getTemplate(name, data = null) {

    let templates = getComment(document.querySelector('#templates'))
    let div = document.createElement('div');
    div.innerHTML = templates;

    let template = div.querySelector(`template[data-name="${name}"]`);
    if (template) {
        let content = template.innerHTML.trim();
        return data ? eval('`' + content + '`') : content;
    }
}
/**
 * Retourne le nombre de lignes théorique d'un texte (ligne de 80 signes le longueur)
 * @param {string} txt 
 * @returns {int}
 */
function nblines(txt) {
    let tab = txt.split('\n');
    let out = 0;
    for (i in tab) {
        let line = tab[i] + '';
        if (line) {
            out += line.match(/.{1,80}/g).length;
        }
    }

    return out;
}

/**
 * lire une valeur dans le localstorage
 * @param {string} key 
 * @param {mixed} defaultValue 
 * @returns {mixed}
 */
function getReglage(key, defaultValue = false) {
    let reglages = JSON.parse(localStorage.getItem('reglages') || '{}');
    return reglages[key] || defaultValue;
}

/**
 * Sauver une valeur dans le localstorage
 * @param {string} key 
 * @param {mixed} value 
 * @returns {mixed}
 */
function setReglage(key, value) {
    let reglages = JSON.parse(localStorage.getItem('reglages') || '{}');
    reglages[key] = value;
    localStorage.setItem('reglages', JSON.stringify(reglages));
}

/**
 * lire une valeur dans le sessionstorage
 * @param {string} key 
 * @param {mixed} defaultValue 
 * @returns {mixed}
 */
function getValeur(key, options = {}) {
    options.default = options.default || false;
    let data = JSON.parse(sessionStorage.getItem('data') || '{}');
    let ret = data[key] || options.default;
    if (options.clear) {
        setValeur(key, null);
    }
    return ret;
}

/**
 * Sauver une valeur dans le sessionstorage
 * @param {string} key La clé à enregistrer dans le stokcage de session
 * @param {mixed} value valeur à sauver. Si null, l'index key est retiré du stockage
 * @returns {mixed}
 */
function setValeur(key, value) {
    let data = JSON.parse(sessionStorage.getItem('data') || '{}');
    if (value === null) {
        if (key in data) {
            delete data[key];
        }
    } else {
        data[key] = value;
    }
    sessionStorage.setItem('data', JSON.stringify(data));
}


/**
 * Emettre un event custom
 * @param {string} nom 
 * @param {object} detail données envoyées à l'event
 * @param {object} module référence au module js qui a émis l'event
 */
function emettreEvenement(nom, detail = {}, module = null) {
    log('Evenement custom', { nom, detail });
    const event = new CustomEvent(nom);
    // const event = new CustomEvent(nom, { detail });
    event.data = detail;
    event.module = module;
    document.dispatchEvent(event);
}

function copier_objet(obj) {
    return JSON.parse(JSON.stringify(obj));
}

function strip_tags(s) {
    return s.replace(/(<([^>]+)>)/gi, "");
}


/**
 * Centrer l'element dans la page, avec un smooth scroll
 * @param {DomElement} element 
 */
function centrer(element) {
    element.scrollIntoView({
        block: 'center',
        inline: 'center',
        behaviour: 'smooth'
    });
}


/**
 * Debounce de code : Faire en sorte que le code envoyé en paramètre ne soit pas éxécuté plus d'une fois dans un intervalle de temps défini par la valeur de delay
 * 
 * Prototype d'appel alternatif sans id : attendre(() => { ... })
 * Dans ce cas, l'id sera généré automatiquement.
 * @param {string} id L'identifiant du code à éxécuter
 * @param {function} code Le code à éxecuter
 * @param {int} delay Le delai d'attente en ms (défaut : 500)
 */
var attendreList = {};
const attendre = (id, code = false, delay = 500) => {
    if (typeof id == 'function' && !code) {
        code = id;
        id = md5(code);
    }

    if (attendreList[id]) {
        clearTimeout(attendreList[id]);
    }
    // tenter(() => {
    //     clearTimeout(attendreList[id]);
    // });
    attendreList[id] = setTimeout(code, delay);
}

/**
 * Debounce de code : Faire en sorte que le code envoyé en paramètre ne soit pas éxécuté plus d'une fois dans un intervalle de temps défini par la valeur de delay. Meme fonction que "attendre()" mais avec un parametre unique
 * 
 * @param {object} code le code à éxécuter
 * @param {object} params Les paramètres à envoyer
 */
var patienterList = {};
const patienter = (code, params = {}) => {

    if (code) {
        const id = md5(code);
        const delay = params.delay || 500;

        tenter(() => {
            clearTimeout(patienterList[id]);
        });
        patienterList[id] = setTimeout(code, delay);
    }
}

/**
 * Executer du code dans un try/catch pour éviter les messages d'erreur et les interruptons d'éxécution
 * Utile dans le cas d'un code pouvant générer souvent des erreur
 * @param {function} code le code à éxécuter
 * @return {mixed} La valeur retournée par le code à éxécuter
 * @return {error} L'erreur eventuelle
 */
const tenter = (code) => {
    try {
        return code();
    } catch (e) {
        console.log(e);
        return e;
    }
}

/**
 * Chargement asynchrone d'un script JS externe
 * @param {string} url Url du script
 * @param {function} onload Evenement éxécuté quand le fichier JS sera chargé
 * @param {boolean} async Positionner un attribut async sur le tag <SCRIPT>
 * @param {boolean} defer Positionner un attribut defer sur le tag <SCRIPT>
 */
function script_load(url, onload = false, async = false, defer = false) {
    let script = document.createElement('script');
    script.src = url;
    if (async) {
        script.setAttribute('async', true);
    }
    if (defer) {
        script.setAttribute('defer', true);
    }
    if (onload) {
        script.onload = onload;
    }
    script.type = 'text/javascript';
    (document.head || document.body).appendChild(script);
}


/**
 * Calculer un hash md5
 */
var md5 = function (d) { var r = M(V(Y(X(d), 8 * d.length))); return r.toLowerCase() };

function M(d) { for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++) _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _); return f }

function X(d) { for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) _[m] = 0; for (m = 0; m < 8 * d.length; m += 8) _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32; return _ }

function V(d) { for (var _ = "", m = 0; m < 32 * d.length; m += 8) _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255); return _ }

function Y(d, _) {
    d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;
    for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
        var h = m,
            t = f,
            g = r,
            e = i;
        f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e)
    }
    return Array(m, f, r, i)
}

function md5_cmn(d, _, m, f, r, i) { return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m) }

function md5_ff(d, _, m, f, r, i, n) { return md5_cmn(_ & m | ~_ & f, d, _, r, i, n) }

function md5_gg(d, _, m, f, r, i, n) { return md5_cmn(_ & f | m & ~f, d, _, r, i, n) }

function md5_hh(d, _, m, f, r, i, n) { return md5_cmn(_ ^ m ^ f, d, _, r, i, n) }

function md5_ii(d, _, m, f, r, i, n) { return md5_cmn(m ^ (_ | ~f), d, _, r, i, n) }

function safe_add(d, _) { var m = (65535 & d) + (65535 & _); return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m }

function bit_rol(d, _) { return d << _ | d >>> 32 - _ }


// Selon la couleur en paramètre(rgb), la fonction renvoie la couleur noire ou blanche pour que le contraste soit parfait pour le texte.
function getCouleurTexte(tab) {
    let red = tab['r'];
    let green = tab['g'];
    let blue = tab['b'];
    if (red * 0.299 + green * 0.587 + blue * 0.114 > 150) {
        return [
            '#000',
            '#fff',
            'grayscale(100%)'
        ];
    } else {
        return ["#fff", "#000", 'invert(100%) sepia(100%) saturate(0%) hue-rotate(304deg) brightness(101%) contrast(106%)'];
    }
}

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}




/**
 * Retourne le premier commentaire HTML contenu dans un element
 * 
 * @param {jQueryElement} element 
 * @returns 
 */
function getComment(element) {
    if (element) {
        let comments = getAllComments(element);
        if (comments) {
            return comments?.pop()?.trim();
        }
    }
}


/**
 * Retourne les commentaires HTML contenus dans un element
 * @param {DOMObject} element 
 * @returns 
 */
function getAllComments(element) {
    if (element) {
        function filterNone() {
            return NodeFilter.FILTER_ACCEPT;
        }

        var comments = [];
        // Fourth argument, which is actually obsolete according to the DOM4 standard, is required in IE 11
        var iterator = document.createNodeIterator(element, NodeFilter.SHOW_COMMENT, filterNone, false);
        var curNode;
        while (curNode = iterator.nextNode()) {
            comments.push(curNode.nodeValue);
        }
        return comments;
    }
}
